import React from 'react';
import { isEmpty } from 'lodash';
import { ContentSlideShow } from 'Components/frameworks/content-slideshow/ContentSlideShow';
import { Image } from 'Components/frameworks/image/Image';
export type AwardProps = {
  altMsg?: string;
  imageUrl: string;
};
type Props = {
  awards: Array<AwardProps>;
  className?: string;
};
export const TripAdvisorAwards = ({ awards = [], className }: Props) => {
  if (isEmpty(awards)) {
    return null;
  }

  return (
    <section className={className}>
      <ContentSlideShow>
        {awards.map(({ altMsg, imageUrl }) => {
          return imageUrl ? (
            <article className="overflow-hidden px-5 text-center leading-0" key={imageUrl}>
              <Image
                altMsg={altMsg}
                className="mx-auto"
                classNameImg="max-h-140"
                dontChangeAnything
                imageUrl={imageUrl}
              />
            </article>
          ) : null;
        })}
      </ContentSlideShow>
    </section>
  );
};
